import React  from 'react';
import Iframe from "./index";

const Youtube = ({id}: {id: string}) => <Iframe
    src={`https://www.youtube-nocookie.com/embed/${id}`}
    allowFullScreen={true}
/>;

export default Youtube;